module.exports = __webpack_public_path__ + "static/media/clock-fill.b26f0281.svg";